import React from "react";
import Category from "../components/Category";
import FilterSection from "../components/FilterSection";
import FilterTab from "../components/FilterTab";
import FollowUs from "../components/FollowUs";
import Footer from "../components/Footer";
import MorqueSlider from "../components/MorqueSlider";
import Navbar from "../components/Navbar";
import SeasonFav from "../components/SeasonFav";
import SliderSection from "../components/SliderSection";
import Subscribe from "../components/Subscribe";
import AccessoriesFilter from "../components/AccessoriesFilter";

function Home() {
 
  return (
    <div id="home" className="">
     
      <Navbar/>
      <Category />
      <SliderSection />
      <MorqueSlider />
      <FilterSection/>
      <AccessoriesFilter/>
      <SeasonFav />
      <FilterTab />
      <FollowUs />
      <Subscribe />
      <Footer />
    </div>
  );
}

export default Home;
